import React from "react";
import { Grid } from "@mui/material";
import UserManagement from "../../Modules/User/UserManagement";

export const UserTable = () => {
    return(
        <React.Fragment>
            <Grid item alignItems={"center"} justifyContent={"center"} width={'90%'} sx={{m:2}} >
                <UserManagement userCategory = {'admin'}></UserManagement>
                <UserManagement userCategory = {'edit'}></UserManagement>
                <UserManagement userCategory = {'ban'}></UserManagement>
            </Grid>            
        </React.Fragment>
    )
} 